import { isProduction } from '@/utils/isProduction';

export const GOOGLE_TOKEN = {
  DEV: {
    RECAPTCHA_V3: '6LcNnTkrAAAAAKlfAtWN3yzOHKXkHIl859jEIjkS',
    RECAPTCHA_V2: '6Lfv43orAAAAADfDugWXsT_JM0uwRkUpxaT5W8B-',
    ANALYTICS: 'G-8J74G3JTML',
  },
  PROD: {
    RECAPTCHA_V3: '6LfcKO8qAAAAAKzGFO-scls42ML8ZCvhF3zJgUqQ',
    RECAPTCHA_V2: '6LfuQH0rAAAAAMyzfEzLXg5NkXiy9hAPC61jifDH',
    ANALYTICS: 'G-XQD36M2W9M',
  },
};

export function getGoogleToken(tokenType: 'RECAPTCHA_V3' | 'RECAPTCHA_V2' | 'ANALYTICS') {
  const ENV_TYPE = isProduction() ? 'PROD' : 'DEV';
  return GOOGLE_TOKEN[ENV_TYPE][tokenType];
}
